import { ADDEDFILTER } from "./actionIdentifier";

const addedFilter = (term) => {
    return {
        type: ADDEDFILTER,
        payload: term,
    };
};

export default addedFilter;
